"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultInputs = {
  heightOfTroughUpperEdge: {
    min: 500,
    max: 1000
  },
  plateWidth: {
    min: 200,
    max: 3600
  },
  plateDepth: {
    min: 400,
    max: 600
  },
  plateThickness: {
    min: 25,
    max: 25
  },
  angle: {
    min: 88,
    max: 92
  },
  apronHeight: {
    min: 30,
    max: 150
  },
  apronHeightWithCutOuts: {
    min: 150,
    max: 150
  },
  backSplash: {
    min: 10,
    max: 100
  }
};
exports.insertBrackets = {
  mm370: {
    min: 400,
    max: 500
  },
  mm450: {
    min: 501,
    max: 600
  }
};
exports.individualRecessBuffer = {
  round: 30,
  square: {
    min: 30,
    max: 30
  }
}; // Tried to make center to center, but not really working...
// The issue is that the console changes width, as does the trough... so the best thing we can do is know the space between

exports.freeOverhang = {
  atEdgeLastConsole: {
    min: 10,
    max: 100
  },
  consoleToTrough: {
    min: 0,
    max: 150
  },
  consoleAngleBarMzb: {
    min: -35,
    max: -35
  },
  consoleToTroughMZB: {
    min: 0,
    max: 100
  },
  consoleWithBackwall: {
    min: 0,
    max: 530
  },
  angleBar: {
    min: 0,
    max: 150
  },
  angleBarToTroughMZB: {
    min: 0,
    max: 100
  },
  angleBarWithBackwall: {
    min: 0,
    max: 360
  },
  betweenConsoles: {
    min: 0,
    max: 560
  },
  consoleToAngleBar: {
    min: 0,
    max: 390
  },
  betweenTroughsWithBackWall: {
    min: 0,
    max: 400
  },
  plateEdgeToTrough: {
    min: 0,
    max: 180
  },
  cutOut: {
    min: 0,
    max: 100
  },
  cutOutWithBackwall: {
    min: 40,
    max: 100
  }
};
exports.distance = {
  cornerDesign: {
    radius: 100,
    bevel: 100
  },
  wallAB: 55
};
exports.wasteRailSystem = {
  // D15 - Waste rail system always wide in the middle under drop hole, distance to front edge WT
  distFrontEdge: 40,
  // D16 - Waste rail system use at plate depths (from ... to)
  depthDimension: {
    min: 470,
    max: 600
  },
  apronHeight2030053538: {
    min: 25,
    max: 60
  },
  apronHeight2030053539: {
    min: 61,
    max: 150
  }
};
exports.installaionParts = {
  consoles: {
    stainlessSteel: {
      min: 40,
      max: 40
    },
    stainlessSteelWhite: {
      min: 40,
      max: 40
    },
    miranit: {
      min: 170,
      max: 170
    }
  },
  buffers: {
    stainlessSteel: {
      left: 10,
      right: 10
    },
    stainlessSteelWhite: {
      left: 10,
      right: 10
    },
    miranit: {
      left: 0,
      right: 0
    },
    apron: {
      left: 2,
      right: 2
    }
  },
  angleBarWidth: 40,
  angleBarLength: 380,
  safetyCatch: 30,
  soapDispenser: 85,
  rodan: {
    sleeve: {
      eBS602E: 150,
      rodx605tt: {
        min: 195,
        max: 330
      },
      rodx607tt: {
        min: 175,
        max: 175
      }
    },
    paperTowelDispenser: {
      rodx600tt: {
        min: 180,
        max: 330
      }
    }
  },
  wasteRailSystem: {
    depth: {
      min: 300,
      max: 470
    },
    herf2030053538: 630,
    herf2030053539: 720
  },
  tissueDispenserWidth: 300,
  tissueDispenserHeight: 125,
  tissueDispenserCutWidth: 125.5,
  tissueDispenserCutHeight: 38,
  towelHolder: {
    width: 400,
    height: 55,
    distToUpperEdge: 65
  },
  towelPole: null
};
exports.techSpecs = {
  // D11 - on the side Wall always an angle bar, centered to the total Table depth
  totalTableDepth: null,
  // D12 - without pre built Back wall always 1 pair trigger guard (positioning prferable. far outside minimum.)
  withoutPreBuiltBackwall: 100,
  // D13 - Consoles as middle as possible between the troughs (on a console)
  oneConsole: null,
  // D14 - Consoles as close to trough as possible (with multiple consoles)
  multipleConsoles: null,
  wasteRailSystem: exports.wasteRailSystem,
  apronThickness: 18,
  apronBuffer: 2,
  backSplashThickness: 20,
  surgeEdgeThickness: 20,
  surgeEdgeHeight: 3,
  distance: exports.distance,
  freeOverhang: exports.freeOverhang,
  dropHole: 170,
  valveBore: 60,
  soapDispenserHole: 85,
  individualRecessBuffer: exports.individualRecessBuffer,
  insertBrackets: exports.insertBrackets,
  angelBarAt380: {
    min: 400,
    max: 600
  },
  drillHole: 40,
  drillHoles: {
    tap: 35,
    soapDispenser: 25
  },
  drillHoleBuffers: {
    tap: {
      left: (60 - 35) / 2,
      right: (60 - 35) / 2
    },
    soapDispenser: {
      left: (85 - 25) / 2,
      right: (85 - 25) / 2
    }
  }
};
exports.dimensions = {
  defaultInputs: exports.defaultInputs,
  installaionParts: exports.installaionParts,
  techSpecs: exports.techSpecs
};
exports.weights = {
  surface: {
    miranit: 1.7 // g/cm3

  },
  consoles: {
    '370': 1310,
    '450': 1500,
    'miranit': 3620 // grams

  },
  angleBar: 250,
  safetyCatch: 90,
  packaging: 3040,
  palette: 15000 // g/m

};
exports.default = exports.dimensions;